/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import { TextField } from '@material-ui/core';
import { Link, useHistory } from 'react-router-dom';
import { Button, Dropdown } from 'react-bootstrap';
import Tooltip from 'react-bootstrap/Tooltip';
import Box from '@material-ui/core/Box';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { useDispatch, useSelector } from 'react-redux';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import {
  redirectURLLink,
  closeTab,
  convertQuaterToDate,
  isNumeric,
  convertQuaterFromDate,
  handleScrollToEvent,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import {
  dispatchSetDisplayCurrentDisputesPage,
  getNDCActivityHistory,
  getProviderSummaryHeaderAndGrid,
  dispatchProviderSummaryReqHeader,
  dispatchNdcHistoryHeader,
  getExistingCorrLinkIds,
  dispatchClaimsDetailHeader,
  getDisputedClaimDetailsGrid,
  dispatchProviderSummTabData,
  dispatchFullScrrenCurrentDisputes,
  getProviderSummaryGridData,
  dispatchProviderSummaryGrid,
  dispatchProviderSummaryHeaderAndGrid,
  dispatchSaveCancelClaimsDetail,
  dispatchCurrentDisputesErr,
  dispatchGetInvoiceHeader,
  getInvoiceHeader
} from '../store/actions';

import {
  navigateToNextCell,
  onCellFocused,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import CommentVisibleIcon from '../../../../assets/images/commen-visible-icon.svg';
import CommentIcon from '../../../../assets/images/comment-dots.svg';
import {
  navigateToUnitConversion,
  getUnitConversionDetail,
  getNdcGrid,
} from '../../../Maintain/unitConversion/store/actions';
import {
  getNDCDetails,
  setNDCErrorPopupMessage,
  setNDCDetails,
  setCurrentNDCDetailsIndex,
  setCurrentNDCDetailsSelected,
  naviagteToNDCDetailsPageAction,
} from '../../../Display/NDC/store/action';
import _ from 'lodash';
import {
  INPUT_VALUE_GRETER_THAN_TOTAL_COUNT,
  ERR_PAGINATE_VALUE,
} from '../../../../SharedModules/Errors/constantMessageData';

import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import { tabHighLigther } from '../../../../SharedModules/utilities/utilities';
import { navToNDCDetails } from './ConstantData';
import { displayCurrentDisputes } from './gridComponent/TableHead';
import CommentAndCorrespondenceComponent from '../../../../SharedModules/MicroFrontend/CommentAndCorrespondenceComponent';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import { getAccRecNDCSingleData } from '../../../Research/AccountReceivable/MfgAccountsRec/store/actions';
import { getManuARForSglRpcNavFn } from '../../../Research/AccountReceivable/ARCommonFunctions';
import { ndcDetailFirstLoadAction } from '../../../Research/AccountReceivable/AccRecNDCDetail/store/actions';
import { goToArSummaryAccRecNDCSingle } from '../../../Research/AccountReceivable/ARCommonFunctions';

const DisplayCurrentDisputes = () => {
  // local state and variables initialization
  const dispatch = useDispatch();
  const history = useHistory();
  const [disableBtn, setDisableBtn] = React.useState(false);
  const [pageCount, setPageCount] = React.useState();
  const [tableData, setTableData] = React.useState();
  const [totalCount, setTotalCount] = React.useState(0);
  const [headerDetails, setHeaderDetails] = React.useState();
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [gridApi, setGridApi] = React.useState(null);
  const [corrLinkId, setCorrLinkId] = React.useState(null);
  const [linkTableName, setLinkTableName] = React.useState('DRUG_QTR_DETAILS');
  const [hoverCC, setHoverCC] = React.useState(false);
  const [showComments, setShowComments] = React.useState(false);
  const [gridParams, setGridParams] = React.useState(null);
  const [hoverCCSec, setHoverCCSec] = React.useState(false);
  const [hoverUnder, setHoverUnder] = React.useState(false);

  // Use selectors
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const commentsList = useSelector((state) => {
    return state.sharedState.CommentsReducer?.CommentListData;
  });
  const disputes = useSelector(
    (state) =>
      state?.sharedState?.PerformDisputeResolutionReducer?.displayCurrentDispute
  );
  const getErrorMsgs = useSelector(
    (state) =>
      state?.sharedState?.PerformDisputeResolutionReducer
        ?.displayCurrentDisputeError
  );
  const performDisputeResolutionObj = useSelector(
    (state) =>
      state?.sharedState?.PerformDisputeResolutionReducer
        ?.performDisputeResolutionObj
  );
  const currentDisputesFullScreen = useSelector(
    (state) =>
      state?.sharedState?.PerformDisputeResolutionReducer
        ?.currentDisputesFullScreen
  );
  const searchParams = useSelector(
    (state) =>
      state?.sharedState?.PerformDisputeResolutionReducer
        ?.disputeResolutionDetailObj
  );
  const disputesPages = useSelector(
    (state) =>
      state?.sharedState?.PerformDisputeResolutionReducer
        ?.setDisplayCurrentDisputes
  );
  const disputeData = disputes && disputes?.displayDispHeaderAndGridRespVOList;
  const disputeQtrData = disputesPages?.disputesList;

  const callFirstRowSelect = (api) => {
    //setTimeout(() => {
    if (api && api !== null) {
      if (api) {
        api.forEachNode((node) => (node.rowIndex ? 0 : node.setSelected(true)));
        api.setFilterModel(null);
      }
    }
    //}, 1000);
  };
  // Listen for the first render of data
  const onFirstDataRendered = (api) => {
    if (!api) return;
    // Ensure column and row are visible and focused
    callFirstRowSelect(api);
  };
  // on grid ready functionality
  const onGridReady = (params) => {
    setGridApi(params?.api);
    setGridParams(params);
  };

  React.useEffect(() => {
    dispatch(dispatchCurrentDisputesErr([]));
    handleScrollToEvent();
  }, []);

  // set comment icon on if corrLinkId and comment is available
  const handleExistingCommentList = async (data) => {
    if (data && data.length > 0) {
      const result = await getExistingCorrLinkIds({
        corrLinkId: data[
          disputesPages.pageCount - 1
        ]?.currentDisputesGridRespVOList?.map((item) => {
          return item.corrLinkId;
        }),
      });
      const tempObj = data[
        disputesPages.pageCount - 1
      ]?.currentDisputesGridRespVOList?.map((item) => {
        if (
          result &&
          result.data?.length > 0 &&
          result.data.filter((x) => {
            return x === item.corrLinkId;
          }).length > 0
        ) {
          item.ccCommentsExist = 1;
        } else {
          item.ccCommentsExist = 0;
        }
        return item;
      });
      setTableData(tempObj);
      // eslint-disable-next-line no-unused-expressions
      gridParams?.api.refreshCells();
    }
  };

  React.useEffect(() => {
    if (disputes && disputes?.message === 'SUCESS') {
      setTotalCount(disputeData.length);
      setPageCount(disputesPages?.pageCount);
      handleExistingCommentList(disputeData);
    }
  }, [commentsList]);

  //  tab highlighter Functionality
  React.useEffect(() => {
    if (getErrorMsgs && getErrorMsgs.length > 0) {
      tabHighLigther('/displayCurrentDisputes', true);
    } else {
      tabHighLigther('/displayCurrentDisputes', false);
    }
  }, [JSON.stringify(getErrorMsgs)]);

  React.useEffect(() => {
    if (disputeQtrData && disputeQtrData?.length > 0) {
      if (
        disputeQtrData?.length > 0 &&
        disputesPages.pageCount === totalCount
      ) {
        handleExistingCommentList(disputeQtrData);
      }
    }
  }, [disputeQtrData, commentsList]);
  // Pagination left arrow click function
  const clickPrevious = () => {
    if (getErrorMsgs.length === 0) {
      setPageCount(disputesPages?.pageCount - 1);
      dispatch(
        dispatchSetDisplayCurrentDisputesPage({
          pageCount: disputesPages?.pageCount - 1,
          disputesList: disputeData,
        })
      );
      if (disputeData) {
        setTableData(disputeData[pageCount - 2]?.currentDisputesGridRespVOList);
      }
    }
  };

  // Pagination right arrow click function
  const clickNextRow = () => {
    if (getErrorMsgs.length === 0) {
      setPageCount(parseInt(disputesPages.pageCount) + 1);
      dispatch(
        dispatchSetDisplayCurrentDisputesPage({
          pageCount: parseInt(disputesPages.pageCount) + 1,
          disputesList: disputeData,
        })
      );
      setTableData(
        disputeData[disputesPages.pageCount]?.currentDisputesGridRespVOList
      );
    }
  };

  // Pagination input field change function
  const handlePage = (e) => {
    const noErrors =
      getErrorMsgs.filter((e) => e.field !== 'pagination')?.length === 0;
    const count = e.target.value;
    if (noErrors) {
      setPageCount(count);
      if (count !== 0 && count <= totalCount) {
        dispatch(
          dispatchSetDisplayCurrentDisputesPage({
            pageCount: count,
            disputesList: disputeData,
          })
        );
        setTableData(disputeData[count - 1]?.currentDisputesGridRespVOList);
      }
    }
  };

  const onBlurPagination = () => {
    // pushing error msg
    let localErr = [];
    let invalidVal = isNumeric(pageCount);
    if (pageCount !== 0 && pageCount > totalCount) {
      localErr.push({
        field: 'pagination',
        errorType: 'required',
        message: INPUT_VALUE_GRETER_THAN_TOTAL_COUNT,
      });
      dispatch(dispatchCurrentDisputesErr(localErr));
    } else if (pageCount == 0 || !invalidVal) {
      localErr.push({
        field: 'pagination',
        errorType: 'required',
        message: ERR_PAGINATE_VALUE,
      });
      dispatch(dispatchCurrentDisputesErr(localErr));
    } else {
      localErr = localErr.filter((e) => e.field !== 'pagination');
      dispatch(dispatchCurrentDisputesErr([]));
    }
  };

  // fullscreen functionality
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
    dispatch(dispatchFullScrrenCurrentDisputes(fullScreenView));
  };

  const clickHandlerOnProcess = async (data) => {};

  // Go to Account Receivable NDC details
  const handleGoToAccRecNDCDetail = async (row) => {
    const reqPayload = {
      planType: performDisputeResolutionObj?.state?.planTypeCd,
      startQtr: row.qtr,
      endQtr: row.qtr,
      useOfficialURA: 1,
      mfgId: searchParams?.mfgID,
      rebateProgram: performDisputeResolutionObj?.state?.rebateProgramCd,
    };
    let invoiceDetails = await dispatch(getManuARForSglRpcNavFn(reqPayload));
    const invoiceData =
      invoiceDetails?.accountReceivableDetailSforSingleMfgGridResponseVOs
        ?.infoList[0];
    if (row) {
      const obj = {
        mfgId: searchParams?.mfgID,
        mfgName: searchParams?.mfgName,
        invoiceNum: invoiceData?.invoiceNum,
        invoiceDate: invoiceData?.invoiceDate,
        invoiceStatus: invoiceData?.invoiceStatus,
        uraInfo: 'Official',
        useOfficialURA: 1,
        qtr: row.qtr,
        pgmInfo: performDisputeResolutionObj?.state?.rebateProgramCd,
        pgmCd: performDisputeResolutionObj?.state?.rebateProgramCd,
      };
      let payload = {
        mfgId: searchParams?.mfgID,
        startQuarter: row.qtr,
        aiUseOfficialURA: 1,
        invoiceNumber: parseInt(row.createInvRecSeqNum),
        rebateProgramCd: performDisputeResolutionObj?.state?.rebateProgramCd,
      };
      let accountRecResponse = await dispatch(
        getAccRecNDCSingleData(payload, obj)
      );
      if (!_.isEmpty(accountRecResponse)) {
        dispatch(ndcDetailFirstLoadAction(false));
        goToArSummaryAccRecNDCSingle(
          history,
          performDisputeResolutionObj?.state?.rebateProgramCd,
          dispatch
        );
      }
    }
  };

  // Go to maintain unit conversion screen
  const goToUnitConversion = async (data) => {
    dispatch(getUnitConversionDetail({ drugSeqNum: [data?.drugSeqNum] }));
    const result = await dispatch(getNdcGrid({ drugSeqNum: data?.drugSeqNum }));
    // if (result.payLoad && result.payLoad?.length > 0) {
    redirectURLLink(
      '/unitConversion-detail',
      'Display Unit Conversion for NDC',
      history,
      dispatch
    );
  };

  // handle disputed claims details redirection
  const handleDisputedClaimsDetail = async (data, cellData) => {
    const quarter = data.disputesList[data.pageCount - 1]?.qtr;
    const fromdate = convertQuaterFromDate(quarter);
    const todate = convertQuaterToDate(quarter);
    const payloadClaimsDetails = {
      rebateProgramCd: performDisputeResolutionObj?.state?.rebateProgramCd,
      drugSeqNum: cellData.drugSeqNum,
      claimPaidBeginDate: fromdate,
      claimPaidEndDate: todate,
      providerUnused: '1',
      providerId: null,
      providerIdTypeCd: null,
      displayInvoiced: '1',
      displayNonInvoiced: '0',
    };
    const reqData = {
      payloadClaimsDetails,
      ndc: cellData.ndc,
      drugName: cellData.drugName,
      mfgName: searchParams?.mfgName,
      mfgID: searchParams?.mfgID,
      quarter,
      rebateProgramCd: performDisputeResolutionObj?.state?.rebateProgramCd,
    };
    const result = await dispatch(
      getDisputedClaimDetailsGrid(payloadClaimsDetails)
    );
    dispatch(dispatchClaimsDetailHeader(reqData));
    dispatch(dispatchSaveCancelClaimsDetail(true));
    redirectURLLink(
      '/disputedClaimsDetail',
      'Disputed Claims Detail',
      history,
      dispatch
    );
  };

  // handle ndc activity history details redirection
  const handleNdcActivityRedirection = async (data) => {
    const payload = {
      drugSeqNum: data.drugSeqNum,
      rebateProgramCd: performDisputeResolutionObj?.state?.rebateProgramCd,
      quarter: data?.qtr,
    };
    const result = await dispatch(getNDCActivityHistory(payload));
    const ndcHistoryHeader = { data, payload };
    dispatch(dispatchNdcHistoryHeader(ndcHistoryHeader));
    redirectURLLink('/ndcHistory', 'NDC History', history, dispatch);
  };
    const handleGetInvoiceDetails = (data) => {
      dispatch(dispatchGetInvoiceHeader({}));
      dispatch(
        getInvoiceHeader({
          isMFG: data?.mfgId,
          isPrevQTR: data?.quarter,
          isProgramCode: data?.rebateProgram,
        })
      );
    };

  // Provider Summary Header and grid
  const handleProviderSummaryHeaderAndGrid = async (data) => {
    const payloadProvider = {
      drugSeqNum: data?.drugSeqNum,
      rebateProgramCd: performDisputeResolutionObj?.state?.rebateProgramCd,
      qtr: data?.qtr,
      mfgName: searchParams.mfgName,
    };
    const payForDetail = {
        rebateProgram: performDisputeResolutionObj?.state?.rebateProgramCd,
        quarter:  data?.qtr,
        mfgId: searchParams?.mfgID,
      };
    const providerReqValues = { data, payloadProvider };
    handleGetInvoiceDetails(payForDetail);
    dispatch(dispatchProviderSummTabData({}));
    dispatch(dispatchProviderSummaryGrid([]));
    dispatch(dispatchProviderSummaryHeaderAndGrid({}));
    // const result = await dispatch(getProviderSummaryHeaderAndGrid(payloadProvider));
    const provData = await dispatch(
      getProviderSummaryGridData(payloadProvider)
    );
    dispatch(dispatchProviderSummaryReqHeader(providerReqValues));
    redirectURLLink('/providerSummary', 'Provider Summary', history, dispatch);
  };

  return (
    <div className="tabs-container" data-testid="display-current-disputes">
      <CustomSeparator
        parent1="Request Current Dispute Display"
        parent2="Display Current Disputes"
      />
      <Spinner load={spinnerLoader} />
      {getErrorMsgs?.length > 0 ? (
        <DisplayErrorMessages
          errorMessages={[...new Set(_.map(getErrorMsgs, (l) => l.message))]}
        />
      ) : null}
      <Box className="alone-pagination mb-2">
        <Box>
          <Button
            title="Previous "
            className="btns rotate-left"
            data-testid="uc-paginate-arrow-left"
            type="button"
            onClick={clickPrevious}
            disabled={disputesPages?.pageCount <= 1 ? true : false}
          >
            <SVGComponent iconName="Icon-arrow" />
            <span className="hide-elm">Previous</span>
          </Button>
        </Box>
        <Box>
          <label className="m-0" htmlFor="paginate-count">
            <TextField
              id="paginate-count"
              data-testid="uc-input-paginate"
              variant="outlined"
              className="searchInput input-count"
              size="small"
              value={pageCount === 0 ? pageCount + 1 : pageCount}
              onChange={(e) => handlePage(e)}
              onBlur={onBlurPagination}
            />
          </label>
        </Box>
        <Box className="btns">
          Of
          {` ${totalCount}`}
        </Box>
        <Box>
          <Button
            title="Next "
            className="btns rotate-right ml-0"
            data-testid="uc-paginate-arrow-right"
            type="button"
            onClick={clickNextRow}
            disabled={disputesPages?.pageCount >= totalCount ? true : false}
          >
            <SVGComponent iconName="Icon-arrow" />
            <span className="hide-elm">Next</span>
          </Button>
        </Box>
      </Box>

      <div className="row">
        {!currentDisputesFullScreen && (
          <div
            className="col-12 mui-custom-form no-margin"
            style={{ width: '100%' }}
          >
            <fieldset className="custom-fieldset custom-height">
              <legend className="d-none" />
              <div className="form-wrapper db">
                <div className="row">
                  <div className="col-12 col-sm-4">
                    <div className="form-wrapper vertical-wrapper">
                      <div className="mui-custom-form with-select input-md override-width-95 d-flex flex-column">
                        <TextField
                          data-testid="-textField"
                          id="manufactur-id"
                          label="Manufacturer ID"
                          fullWidth
                          disabled
                          placeholder=""
                          value={searchParams?.mfgID}
                          inputProps={{ maxLength: 38, id: 'manufactur-id' }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-sm-4">
                    <div className="form-wrapper vertical-wrapper">
                      <div className="mui-custom-form with-select input-md override-width-95 d-flex flex-column">
                        {searchParams?.mfgName &&
                        searchParams.mfgName !== '' &&
                        searchParams.mfgName.length > 25 ? (
                          <OverlayTrigger
                            placement="bottom"
                            overlay={
                              <Tooltip id="labeler-tooltip">
                                {searchParams.mfgName}
                              </Tooltip>
                            }
                          >
                            <TextField
                              data-testid="manufacturer-name-tool-textField"
                              id="manufacturer-name-id-tooltip"
                              label="Manufacturer Name"
                              fullWidth
                              disabled
                              placeholder=""
                              value={
                                searchParams?.mfgName != null &&
                                searchParams?.mfgName.length > 0
                                  ? `${searchParams.mfgName.substring(
                                      0,
                                      25
                                    )}...`
                                  : ''
                              }
                              inputProps={{ maxLength: 38, id: 'Name-id' }}
                              InputLabelProps={{
                                shrink: true,
                              }}
                            />
                          </OverlayTrigger>
                        ) : (
                          <TextField
                            data-testid="manufacturer-name-textField"
                            id="manufacturer-name-id"
                            label="Manufacturer Name"
                            fullWidth
                            disabled
                            placeholder=""
                            value={searchParams?.mfgName}
                            inputProps={{ maxLength: 38, id: 'Name-id' }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-sm-4">
                    <div className="form-wrapper vertical-wrapper">
                      <div className="mui-custom-form with-select input-md override-width-95 d-flex flex-column">
                        <TextField
                          data-testid="-textField"
                          id="rebate-id"
                          label="Quarter"
                          fullWidth
                          disabled
                          placeholder=""
                          value={
                            disputeQtrData.length
                              ? disputeQtrData[disputesPages?.pageCount - 1]
                                  ?.qtr
                              : searchParams?.qtr
                          }
                          inputProps={{ maxLength: 38 }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-sm-4">
                    <div className="form-wrapper vertical-wrapper">
                      <div className="mui-custom-form with-select input-md override-width-95 d-flex flex-column">
                        <TextField
                          data-testid="-textField"
                          id="paid-date-range-id"
                          label="Amount Under Dispute"
                          fullWidth
                          disabled
                          placeholder=""
                          value={`${
                            disputeQtrData?.length > 0
                              ? parseFloat(
                                  disputeQtrData[disputesPages.pageCount - 1]
                                    ?.amountUnderDispute
                                ) >= 0
                                ? `$ ${parseFloat(
                                    disputeQtrData[disputesPages.pageCount - 1]
                                      ?.amountUnderDispute
                                  ).toLocaleString('en-US', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}`
                                : `($ ${parseFloat(
                                    disputeQtrData[disputesPages.pageCount - 1]
                                      ?.amountUnderDispute
                                  )
                                    ?.toString()
                                    ?.replace('-', '')
                                    .trim()})`
                              : '$ 0.00'
                          }`}
                          inputProps={{
                            maxLength: 38,
                            id: 'paid-date-range-id',
                          }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-sm-4">
                    <div className="form-wrapper vertical-wrapper">
                      <div className="mui-custom-form with-select input-md override-width-95 d-flex flex-column">
                        <TextField
                          data-testid="-textField"
                          id="ndc-id"
                          fullWidth
                          disabled
                          label="Interest for Quarter"
                          placeholder=""
                          value={`${
                            disputeQtrData?.length > 0
                              ? parseFloat(
                                  disputeQtrData[disputesPages.pageCount - 1]
                                    ?.interestForQuarter
                                ) >= 0
                                ? `$ ${parseFloat(
                                    disputeQtrData[disputesPages.pageCount - 1]
                                      ?.interestForQuarter
                                  ).toLocaleString('en-US', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}`
                                : `($ ${parseFloat(
                                    disputeQtrData[disputesPages.pageCount - 1]
                                      ?.interestForQuarter
                                  )
                                    ?.toString()
                                    ?.replace('-', '')
                                    .trim()})`
                              : '$ 0.00'
                          }`}
                          inputProps={{ maxLength: 38, id: 'ndc-id' }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-sm-4">
                    <div className="form-wrapper vertical-wrapper">
                      <div className="mui-custom-form with-select input-md override-width-95 d-flex flex-column">
                        <TextField
                          data-testid="-textField"
                          id="audit-id"
                          fullWidth
                          disabled
                          label="Rebate Program"
                          placeholder=""
                          value={searchParams?.rebatePrograme}
                          inputProps={{ maxLength: 38, id: 'audit-id' }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
        )}
        <div className="col-sm-12 FRR-custom-table tbl-manufacturer-inner frr-log_chk">
          <TableGridWithFeatures
            data-testid="mfg-data-component-grid"
            rowSelection="single"
            rowMultiSelectWithClick={false}
            fullScreenView={currentDisputesFullScreen}
            handleFullScreenViewClick={handleFullScreenView}
            gridHeight={currentDisputesFullScreen ? '70vh' : viewPortHeight_355}
            gridCall={onGridReady}
            gridDataRendered={onFirstDataRendered}
            navigateToNextCell={navigateToNextCell}
            tabToNextCell={tabToNextCell}
            enterMovesDown
            suppressCellFocus
            onCellFocused={onCellFocused}
            exportFile
            animateRows
            sideBar={false}
            isScrollOn
            fileName="Display Current Disputes"
            columnDefs={displayCurrentDisputes}
            rowData={tableData}
            onSelect={(e) => clickHandlerOnProcess(e?.api?.getSelectedRows())}
            frameworkComponents={{
              ActionCellRender: (cellInfo) => {
                const disputesPages = useSelector(
                  (state) =>
                    state?.sharedState?.PerformDisputeResolutionReducer
                      ?.setDisplayCurrentDisputes
                );
                return (
                  <div className="tdCell icon-btn-group">
                    {hoverCCSec ? (
                      <OverlayTrigger
                        placement="bottom"
                        overlay={<Tooltip id="com-tooltip">Comment</Tooltip>}
                      >
                        <Button
                          type="button"
                          aria-label="Comment"
                          onClick={() => {
                            setCorrLinkId(cellInfo && cellInfo.data.corrLinkId);
                            setLinkTableName('DRUG_QTR_DETAILS');
                            setShowComments(true);
                          }}
                          tabIndex={'0'}
                          onKeyDown={(e) => {
                            // Handle Enter and Space key events
                            if (e.key === 'Enter' || e.key === ' ') {
                              e.preventDefault(); // Prevents the default space scrolling behavior
                              setCorrLinkId(
                                cellInfo && cellInfo.data.corrLinkId
                              );
                              setLinkTableName('DRUG_QTR_DETAILS');
                              setShowComments(true);
                            }
                          }}
                          onMouseOver={() => {
                            setHoverCCSec(true);
                          }}
                          onMouseOut={() => {
                            setHoverCCSec(false);
                          }}
                          className="th-ic comment-ic frr-enabled-comment-btn"
                          variant="text"
                        >
                          {parseInt(cellInfo?.data?.ccCommentsExist, [0, 1]) ===
                          1 ? (
                            <img alt="comment " src={CommentVisibleIcon} />
                          ) : (
                            <img alt="comment" src={CommentIcon} />
                          )}
                        </Button>
                      </OverlayTrigger>
                    ) : (
                      <Button
                        type="button"
                        onClick={() => {
                          setCorrLinkId(cellInfo && cellInfo.data.corrLinkId);
                          setLinkTableName('DRUG_QTR_DETAILS');
                          setShowComments(true);
                        }}
                        tabIndex={'0'}
                        onKeyDown={(e) => {
                          // Handle Enter and Space key events
                          if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault(); // Prevents the default space scrolling behavior
                            setCorrLinkId(cellInfo && cellInfo.data.corrLinkId);
                            setLinkTableName('DRUG_QTR_DETAILS');
                            setShowComments(true);
                          }
                        }}
                        onMouseOver={() => {
                          setHoverCCSec(true);
                        }}
                        onMouseOut={() => {
                          setHoverCCSec(false);
                        }}
                        className="th-ic comment-ic frr-enabled-comment-btn"
                        variant="text"
                      >
                        {parseInt(cellInfo?.data?.ccCommentsExist, [0, 1]) ===
                        1 ? (
                          <img alt="comment" src={CommentVisibleIcon} />
                        ) : (
                          <img alt="comment" src={CommentIcon} />
                        )}
                      </Button>
                    )}
                    <Dropdown className="icon-dropdown-container float-right">
                      <Dropdown.Toggle
                        className="icon-dropdown"
                        aria-label="Export"
                      >
                        <OverlayTrigger
                          placement="bottom"
                          overlay={
                            <Tooltip id="action-tooltip">Action</Tooltip>
                          }
                        >
                          <SVGComponent iconName="Icon-export1" />
                        </OverlayTrigger>
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="export_dropdown h-auto">
                        <Dropdown.Item
                          role="button"
                          onClick={() =>
                            handleGoToAccRecNDCDetail(cellInfo?.data)
                          }
                        >
                          {' '}
                          Go to Accounts Receivable NDC Details
                        </Dropdown.Item>
                        <Dropdown.Item
                          role="button"
                          onClick={() => {
                            goToUnitConversion(cellInfo?.data);
                          }}
                        >
                          {' '}
                          Go to Maintain Unit Conversion
                        </Dropdown.Item>
                        <Dropdown.Item
                          role="button"
                          onClick={() => {
                            handleProviderSummaryHeaderAndGrid(cellInfo?.data);
                          }}
                        >
                          {' '}
                          Go to Provider Summary
                        </Dropdown.Item>
                        <Dropdown.Item
                          role="button"
                          onClick={() => {
                            handleDisputedClaimsDetail(
                              disputesPages,
                              cellInfo?.data
                            );
                          }}
                        >
                          {' '}
                          Go to Claims
                        </Dropdown.Item>
                        <Dropdown.Item
                          role="button"
                          onClick={() => {
                            handleNdcActivityRedirection(cellInfo?.data);
                          }}
                        >
                          {' '}
                          Go to NDC History
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                );
              },
              NDCCellRender: (cellInfo) => {
                const goToNdcDetails = async () => {
                  const response = await getNDCDetails([
                    {
                      ndc: cellInfo.data.ndc,
                      drugName: cellInfo.data.drugName,
                    },
                  ]);
                  if (response) {
                    dispatch(setNDCErrorPopupMessage(null));
                    dispatch(setCurrentNDCDetailsIndex(1));
                    dispatch(setCurrentNDCDetailsSelected(response[0], 'All'));
                    dispatch(
                      setNDCDetails([
                        {
                          ndc: cellInfo.data.ndc,
                          drugName: cellInfo.data.drugName,
                        },
                      ])
                    );
                    redirectURLLink(
                      navToNDCDetails,
                      'NDC Details',
                      history,
                      dispatch
                    );
                  }
                };
                return (
                  <div
                    className={
                      hoverUnder ? 'frr-text-decoration-underline' : ''
                    }
                  >
                    <Link
                      to="#"
                      role="button"
                      onClick={() => goToNdcDetails()}
                      onMouseOver={() => {
                        setHoverUnder(true);
                      }}
                      onMouseOut={() => {
                        setHoverUnder(false);
                      }}
                    >
                      {cellInfo && cellInfo?.data?.ndc}
                    </Link>
                  </div>
                );
              },
              DrugNameRenderer: (cellInfo) => {
                if (cellInfo.value?.length > 20) {
                  return (
                    <OverlayTrigger
                      placement="bottom"
                      overlay={
                        <Tooltip id="labeler-tooltip">
                          {cellInfo.data.drugName}
                        </Tooltip>
                      }
                    >
                      <div>{cellInfo.data.drugName}</div>
                    </OverlayTrigger>
                  );
                }
                return <div>{cellInfo.value}</div>;
              },
              interestDueCellRenderer: (cellInfo) => {
                const isNegativeVal = !(
                  parseFloat(
                    cellInfo?.data?.interestDue?.toString().split('$')[1]
                  ) >= 0
                );
                return (
                  <>
                    {isNegativeVal ? (
                      <div
                        style={{ color: 'red' }}
                      >{`(${cellInfo?.data?.interestDue
                        ?.toString()
                        ?.replace('-', '')
                        .trim()})`}</div>
                    ) : (
                      <div>{`${cellInfo?.data?.interestDue}`}</div>
                    )}
                  </>
                );
              },
              dispAmountCellRenderer: (cellInfo) => {
                const value = cellInfo?.data?.dispAmount
                  ?.toString()
                  .split('$')[1];
                const isNegativeVal = !(parseFloat(value) >= 0);
                return (
                  <>
                    {isNegativeVal ? (
                      <div style={{ color: 'red' }}>{`($ ${parseFloat(value)
                        .toFixed(2)
                        ?.toString()
                        ?.replace('-', '')
                        .trim()})`}</div>
                    ) : (
                      <div>{`$ ${parseFloat(value).toFixed(2)}`}</div>
                    )}
                  </>
                );
              },
            }}
          />
        </div>
      </div>
      {showComments ? (
        <CommentAndCorrespondenceComponent
          setShowComments={setShowComments}
          linkTableName={linkTableName}
          corrLinkId={corrLinkId}
        />
      ) : null}
    </div>
  );
};

export default DisplayCurrentDisputes;
